import { objectSpread2 as _objectSpread2, inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import { connect } from 'react-redux';
import { lookupReset } from '../../modules/lookups/actions.js';
import { registerLookup, unregisterLookup } from '../../modules/lookups/config.js';
import { createAutoName } from '../../modules/utility/naming.js';

var _excluded = ["lookupReset"];
var defaultOptions = {
  required: true,
  autoNamePrefix: "withLookup/"
};

var withLookup = function withLookup() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (LookupComponent) {
    var _options = _objectSpread2(_objectSpread2({}, defaultOptions), options);

    var LookupWrapper = /*#__PURE__*/function (_React$Component) {
      _inherits(LookupWrapper, _React$Component);

      var _super = _createSuper(LookupWrapper);

      function LookupWrapper() {
        var _this;

        _classCallCheck(this, LookupWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "_autoLookup", void 0);

        _defineProperty(_assertThisInitialized(_this), "_lookupWarning", false);

        _defineProperty(_assertThisInitialized(_this), "getLookup", function () {
          var _this$props = _this.props,
              lookup = _this$props.lookup,
              lookupAction = _this$props.lookupAction,
              lookupOptions = _this$props.lookupOptions;
          if (_this._autoLookup) return _this._autoLookup;

          if (lookupAction) {
            var name = createAutoName(_options.autoNamePrefix);
            _this._autoLookup = registerLookup(name, lookupAction, lookupOptions);
            return _this._autoLookup;
          }

          if (lookup) return lookup;

          if (!_this._lookupWarning && _options.required) {
            console.warn("".concat(LookupWrapper.displayName, " props lookup/lookupAction have not been defined"));
            _this._lookupWarning = true;
          }

          return undefined;
        });

        return _this;
      }

      _createClass(LookupWrapper, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this._autoLookup) {
            this.props.lookupReset(this._autoLookup);
            unregisterLookup(this._autoLookup);
            this._autoLookup = undefined;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props;
          _this$props2.lookupReset;

          var otherProps = _objectWithoutProperties(_this$props2, _excluded);

          var lookup = this.getLookup();
          return /*#__PURE__*/React.createElement(LookupComponent, _extends({}, otherProps, {
            lookup: lookup
          }));
        }
      }]);

      return LookupWrapper;
    }(React.Component);

    _defineProperty(LookupWrapper, "propTypes", {
      lookupReset: _pt.any.isRequired
    });

    _defineProperty(LookupWrapper, "displayName", "withLookup(".concat(LookupComponent.displayName || LookupComponent.name, ")"));

    return connect(null, {
      lookupReset: lookupReset
    })(LookupWrapper);
  };
};

var withLookup$1 = withLookup;

export { withLookup$1 as default };
